/** Werkzeugleiste links mit Inline-SVG-Icons. */
export interface ToolButtonDef {
  id: string;
  label: string;
  shortcut: string;
  icon: string;
}

const ICONS: Record<string, string> = {
  select: '<path d="M6 3l12 9-5.5 1L15 19l-2.5 1-2.3-6L6 16z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
  line: '<path d="M5 19L19 5" stroke="currentColor" stroke-width="1.8"/><circle cx="5" cy="19" r="2" fill="currentColor"/><circle cx="19" cy="5" r="2" fill="currentColor"/>',
  rectangle: '<rect x="4" y="6" width="16" height="12" fill="none" stroke="currentColor" stroke-width="1.8"/>',
  circle: '<circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="1.4" fill="currentColor"/>',
  arc: '<path d="M4 18C6 8 18 8 20 18" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="4" cy="18" r="1.8" fill="currentColor"/><circle cx="20" cy="18" r="1.8" fill="currentColor"/>',
  pushpull: '<rect x="4" y="13" width="16" height="7" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11V3m0 0l-3.5 3.5M12 3l3.5 3.5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/>',
  move: '<path d="M12 3v18M3 12h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M12 3l-2.5 2.5M12 3l2.5 2.5M12 21l-2.5-2.5M12 21l2.5-2.5M3 12l2.5-2.5M3 12l2.5 2.5M21 12l-2.5-2.5M21 12l-2.5 2.5" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/>',
  rotate: '<path d="M19 12a7 7 0 1 1-3-5.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M16 2.5L16.5 7l4.5-1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
  scale: '<rect x="4" y="10" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 12l8-8m0 0h-5m5 0v5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/>',
  offset: '<rect x="4" y="4" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="8" y="8" width="8" height="8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-dasharray="2.5 2"/>',
  eraser: '<path d="M4 16l8-10 8 6-8 10H8z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 22h11" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>',
  tape: '<rect x="3" y="9" width="18" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M7 9v3M11 9v3M15 9v3M18 9v4" stroke="currentColor" stroke-width="1.4"/>',
  paint: '<path d="M12 3l7 7-7 7-7-7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M19 15c1.5 2 1.5 4 0 5s-3-.5-2-2.5c.6-1.2 2-2.5 2-2.5z" fill="currentColor"/>',
  orbit: '<circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" stroke-width="1.7"/><ellipse cx="12" cy="12" rx="9.5" ry="4" fill="none" stroke="currentColor" stroke-width="1.2" transform="rotate(-18 12 12)"/>',
  pan: '<path d="M4 12h16M12 4v16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-dasharray="3 2.4"/><path d="M7 8L4 12l3 4M17 8l3 4-3 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>',
  zoom: '<circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M16 16l5 5M8.5 11h5M11 8.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
};

export class Toolbar {
  el: HTMLElement;
  private buttons = new Map<string, HTMLButtonElement>();

  constructor(root: HTMLElement, tools: ToolButtonDef[], onPick: (id: string) => void) {
    this.el = document.createElement('div');
    this.el.className = 'toolbar';
    for (const t of tools) {
      const btn = document.createElement('button');
      btn.className = 'tool-btn';
      btn.title = `${t.label} (${t.shortcut})`;
      btn.dataset.tool = t.id;
      btn.innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22">${ICONS[t.id] ?? ''}</svg>`;
      btn.onclick = () => onPick(t.id);
      this.buttons.set(t.id, btn);
      this.el.appendChild(btn);
    }
    root.appendChild(this.el);
  }

  setActive(id: string): void {
    for (const [toolId, btn] of this.buttons) {
      btn.classList.toggle('active', toolId === id);
    }
  }
}
